import React from 'react';
import { ArrowRightIcon, FeatherIcon } from 'lucide-react';

// ASIDE DECISIONS (do not revert without checking with design)
//
// 1. This aside used to explain Nisaba. The name story now lives on /about
//    only. Home teases and hands off, it does not preview. Do not reintroduce
//    the Nisaba explanation here or anywhere else on the home route.
// 2. "including our name" is the curiosity hook. It is deliberately unresolved.
//    Resolving it here removes the reason to click through.
// 3. "Educators are the authors of progress" used to sit on its own above this
//    block. It is the belief the handoff points at, so the two are one unit
//    now: the line leads the callout at its old weight, the rest supports it.
//    Two stacked blocks made the same point twice.
// 4. Teaching Lab Studio is named in the footer and on /about. Naming it here
//    too crowds a callout whose job is the belief and the link.
// 5. "Read one teacher's thread ... you start to see the program" closes the
//    block. That line is a bridge into the leader sections and needs to be the
//    last thing read here.
// 6. Contrast: gray-600 body and primary-700 link on the primary-50 ground,
//    7.30:1 and 7.07:1. Do not drop either to gray-500 or primary-600.
export const ContextFlow = () => {
  return <div className="bg-white" data-id="element-155" data-mp="k3rzmeifjxhk">
      <div className="container mx-auto px-5 sm:px-8" data-id="element-156" data-mp="k4ky6s78jgom">
        <div className="mx-auto max-w-6xl border-t border-gray-200 py-12 md:py-16" data-id="element-157" data-mp="3sjboz2fzcvrc">
          <div className="max-w-3xl" data-id="element-158" data-mp="3nkrzwt63b3ur">
            <h3 className="text-balance font-serif text-h2-mobile font-normal leading-tight text-cyan-950 md:text-h2-desktop" data-id="element-159" data-mp="3nlthzhliwqlz">
              Coaching threads and growth records, in one system
            </h3>
            <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-gray-600 md:text-lg" data-id="element-160" data-mp="1cs8b6ngqbl4">
              A thread is what coaching looks like with one teacher over time: visits, goals, evidence, and the conversations around them, held in order. A growth record is what that thread adds up to.
            </p>
            <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-gray-600 md:text-lg" data-id="element-161" data-mp="3ui626e14e9ov">
              Nisa holds those details so nothing has to be rebuilt before the next conversation. Coaches keep their own workflow and their own judgment about where the work goes next.
            </p>
          </div>

          <aside className="mt-8 flex max-w-2xl items-start gap-3.5 rounded-xl bg-primary-50/70 px-5 py-5 sm:px-6" data-id="element-162" data-mp="c6jdst40lswd">
            <FeatherIcon className="mt-1 h-4 w-4 shrink-0 text-primary-600" strokeWidth={1.75} aria-hidden="true" data-id="element-163" data-mp="3fl5lr6odq15p" />
            <div data-id="element-164" data-mp="3kjp8386vxeyl">
              <p className="font-sans text-base font-medium leading-snug text-cyan-900 md:text-lg" data-id="element-165" data-mp="3kj71bhmljicf">
                Educators are the authors of progress.
              </p>
              <p className="mt-2 text-sm leading-relaxed text-gray-600" data-id="element-166" data-mp="zu9i2ffhpua0">
                That belief shapes everything we build, including our name. We build it alongside coaches across the country.
              </p>
              <a href="/about" className="group mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 underline decoration-primary-300 underline-offset-4 transition-colors hover:text-primary-800" data-id="element-167" data-mp="2pbelleelpgxx">
                Our origins and the team
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.75} aria-hidden="true" data-id="element-168" data-mp="2fiz2gdrkimbg" />
              </a>
            </div>
          </aside>

          <p className="mt-10 max-w-2xl text-[17px] leading-relaxed text-gray-600 md:text-lg" data-id="element-169" data-mp="21lu0aouz67lh">
            Read one teacher’s thread and you see their practice. Read across them and you start to see the program.
          </p>
        </div>
      </div>
    </div>;
};